module.exports = __webpack_public_path__ + "static/media/Dash.efcdba09.svg";